import type { SVGProps } from "react";
import * as React from "react";

const SvgCrop = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#crop_svg__a)">
      <path
        fill="currentColor"
        d="M7.13 1.009a1 1 0 1 0-2-.018zM6 16l-1-.009V16zm17 3a1 1 0 1 0 0-2zM.991 5.13a1 1 0 1 0 .018 2zM16 6V5h-.009zm1 17a1 1 0 1 0 2 0zM5.13.991l-.13 15 2 .018.13-15zM5 16a3 3 0 0 0 .879 2.121l1.414-1.414A1 1 0 0 1 7 16zm.879 2.121A3 3 0 0 0 8 19v-2a1 1 0 0 1-.707-.293zM8 19h15v-2H8zM1.009 7.13l15-.13-.018-2-15 .13zM16 7a1 1 0 0 1 .707.293l1.414-1.414A3 3 0 0 0 16 5zm.707.293A1 1 0 0 1 17 8h2a3 3 0 0 0-.879-2.121zM17 8v15h2V8z"
      />
    </g>
    <defs>
      <clipPath id="crop_svg__a">
        <path
          fill="#fff"
          d="M0 0h24v24H0z"
        />
      </clipPath>
    </defs>
  </svg>
);
export default SvgCrop;
